import Common from '@vendor/js/common';
const _OrderFormOrdersCommonHandler = (function () {
    return {
        // Public functions
        init: function () { },
        handleCreateForm: () => {
            Common.handleModalForm('create_order', {});
        },
        handleEditForm: (url) => {
            Common.handleModalForm('edit_order', {
                loadData: true,
                loadDataUrl: url,
                loadDataUrlReplaceId: true,
            });
        },
    };
})();
window.OrderFormOrdersCommonHandler = _OrderFormOrdersCommonHandler;
